/**
 * Cross-tab navigation for Business Dashboard when opening a board action deep link.
 * Uses window events + sessionStorage so Board (tab) and MeetingSection can react.
 */

export const BUSINESS_DASH_NAVIGATE = "azilis-business-dash-navigate";
export const BOARD_INTRINSIC_NAVIGATE = "azilis-board-intrinsic-navigate";
export const MEETING_HUB_FOCUS = "azilis-meeting-hub-focus";

export const SESSION_MEETING_FOCUS = "azilis_open_meeting";
export const SESSION_CHEMISTRY_NOTIFICATION = "azilis_chemistry_notification_id";
export const SESSION_STRATEGY_ATTENTION = "azilis_strategy_attention_id";

export const MEETING_FOCUS_MAX_AGE_MS = 120_000;

/** @param {unknown} v */
export function toNullableNumber(v) {
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/**
 * Persist meeting focus for MeetingSection to consume after the Meeting tab mounts.
 * @param {number|string} meetingId
 * @param {string} [activeFolder] preparation | minutes | …
 */
export function setSessionMeetingFocus(meetingId, activeFolder = "preparation") {
  try {
    sessionStorage.setItem(
      SESSION_MEETING_FOCUS,
      JSON.stringify({
        id: String(meetingId),
        activeFolder,
        ts: Date.now(),
      }),
    );
  } catch {
    /* ignore */
  }
}

/**
 * @param {number} notificationId
 */
export function setSessionChemistryNotificationId(notificationId) {
  try {
    sessionStorage.setItem(SESSION_CHEMISTRY_NOTIFICATION, String(notificationId));
  } catch {
    /* ignore */
  }
}

/**
 * @param {number} attentionItemId
 */
export function setSessionStrategyAttentionId(attentionItemId) {
  try {
    sessionStorage.setItem(SESSION_STRATEGY_ATTENTION, String(attentionItemId));
  } catch {
    /* ignore */
  }
}

/**
 * @param {{
 *   tab: string,
 *   scrollToChemistry?: boolean,
 *   openChemistryAssessment?: boolean,
 *   governanceSection?: 'chemistry' | 'pulse' | 'training',
 *   openPulseAssessment?: boolean,
 * }} detail
 */
export function dispatchBusinessDashNavigate(detail) {
  window.dispatchEvent(new CustomEvent(BUSINESS_DASH_NAVIGATE, { detail }));
}

/**
 * @param {Record<string, unknown>} detail
 */
export function dispatchBoardIntrinsicNavigate(detail) {
  window.dispatchEvent(
    new CustomEvent(BOARD_INTRINSIC_NAVIGATE, { detail }),
  );
}

/** Default folder for meeting-related action types. */
export function meetingFolderForActionType(actionType) {
  switch (actionType) {
    case "agenda-review":
      return "preparation";
    case "voting":
    case "signature":
      return "minutes";
    default:
      return "preparation";
  }
}
